import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import theme from "../utils/muiTheme";
import { Button } from "@mui/material";

const queryClient = new QueryClient();

export const ErrorFallback = () => {
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate("/main/home");
  };
  return (
    <div
      className="text-red-500 w-screen h-screen flex flex-col justify-center items-center"
      role="alert"
    >
      <h2 className="text-lg font-semibold">Ooops, something went wrong. </h2>
      <Button onClick={navigateBack}>Go Back</Button>
    </div>
  );
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          {/* <Spinner size="xl" /> */}
        </div>
      }
    >
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <Router>
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                {children}
              </ErrorBoundary>
            </Router>
          </ThemeProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </React.Suspense>
  );
};
